<template>
	<div v-loading=loading class='gPageBorder'>
    <el-form label-position="right" class='gTopMg' label-width="14.5%" style="">
      <el-form-item :label="$t('app_hbsp') + '(' + ($t('app_minute')) + ')'" prop="name">
        <!--<el-input></el-input>-->
        <el-input-number v-model="terminalConfigForm.data.set.hb" controls-position="right" :min="1" :max="20"></el-input-number>
      </el-form-item>

      <el-form-item :label="$t('app_checkupsp') + '(' + $t('app_minute') + ')'" prop="name">
        <!--<el-input></el-input>-->
        <el-input-number v-model="terminalConfigForm.checkUpdateTime" controls-position="right" :min="terminalConfigForm.data.set.hb + 5" :max="120"></el-input-number>
      </el-form-item>

      <el-form-item :label="$t('app_rcmsg')">
        <el-checkbox-group v-model="terminalConfigForm.data.get">
          <el-checkbox label="l">{{$t('app_geo')}}</el-checkbox>
          <el-checkbox label="si">{{$t('app_sysinfo')}}</el-checkbox>
          <el-checkbox label="ts">{{$t('app_terstatus')}}</el-checkbox>
          <el-checkbox label="fi">{{$t('app_fminfo')}}</el-checkbox>
        </el-checkbox-group>

      </el-form-item>

      <el-form-item>
        <!-- <el-button>{{$t('lin_global.chongzhi')}}</el-button> -->
        <el-button type="primary" @click="saveTerminalConfig()">{{$t('app_save')}}</el-button>
      </el-form-item>

    </el-form>
	</div>

</template>

<script>
  import jq from 'jquery'
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import AutoTerno from '../global/TernoAutoCtrl'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import ElFormItem from "../../../node_modules/element-ui/packages/form/src/form-item.vue";

  export default{
    components: {
      ElFormItem,
      MechanismSelector, AutoTerno
    },
		data(){
      var that = this
			return {
        // 配置终端参数表单
        raw: '',
        terminalConfigForm: {
          checkUpdateTime: 0,
          pushTime: 20,
          data: {
            get: ['l'],
            set: {
              hb: 10
            }
          }
        },
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.value1 = value
//            that.cSelect(value)
          }
        },
        exInfo: '',
        devices: 0,
        srcList: [],
        isSubmit: false,
        logoCheck: false,
        oldLogo: '',
        loading: 0,
        logo: '',
        logoValue: '',
        activeName: 'first',
        isShow: false,
        options: [{
          value: '0',
            label:this.$t('lin_global.label_areaid')
        }, {
          value: '1',
          label: this.$t('lin_global.shebeibei')
        }, {
          value: '2',
          label: this.$t('app_fileImport')
        }],
        arrdata:[],
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,
        value: '0',
        value1: '',
        areaList1:[],
        setForm:{
          url: '',
          port:''
        },
        url: '',
        port:'',
        rules:{
            'url':[{
              type: 'string',
              required: true,
              message: this.$t('lin_global.fwqdzbnwk')
            }],
            'port':[{
              type: 'string',
              required: true,
              message: this.$t('lin_global.fwqdkhbnwk')
            }]
        }
      }
		},
    computed: {
      imgUploadUrl () {
        return this.$urls.picUrl
      },
      downUrl () {
        return this.$host + '/tms-server-web/model/terminalNos.xlsx'
      }
    },
		created(){
//      this.getAd1();
      this.getData(1);
		},
    watch : {
		  'terminalConfigForm.data.set.hb' (val, old) {
		    var that = this
        if (that.terminalConfigForm.checkUpdateTime < (val + 5)) {
          that.terminalConfigForm.checkUpdateTime = val + 5
        }
      }
    },
		methods:{
		  // 保存终端配置信息
      saveTerminalConfig () {
        var that = this
        //var a = {}
        //jq.extend(a, this.terminalConfigForm)
        //a.pushTime = a.pushTime * 1000 * 60
        var value = JSON.stringify(that.terminalConfigForm, null, 4)
        if (this.raw) {
          this.loading = true
          this.$setDvSetting(this.raw.id, value, (res) => {
            this.loading = false
            this.$message.success(res.message)
          }, (error) => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })
        } else {
          this.$message.error('error')
        }


      },
      onDvInputChange (vl) {
        this.value1 = vl
      },
      pushType (row) {
        switch (row.type) {
          case '0':
            return this.$t('app_distributor')
          break
          case '1':
            return this.$t('app_dv')
          break
          case '2':
            return this.$t('terminal.list.import_btn')
          break
        }
      },
      srcBefore (file) {
        // console.log(file)
        window[this.$route.path] = 1
        /*var name = file.name
        if (name === 'part0.zip') {
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } */
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        console.log('exres', res)
        if (res.status === 200) {
          this.srcList = [{name: file.name}]
          this.exInfo = res.data
          this.exInfo.file = file.name
          this.devices = res.data.terNums
          //this.hBlur('fm')
        } else {
          if (this.exInfo.file) {
            this.srcList = [{name: this.exInfo.file}]
          } else {
            this.srcList = []
          }
          this.$message.error(res.message)
        }
      },
      handleClick(tab, event) {
      },
      defaultLogo () {
        this.loading = 1
        this.$editLogo(localStorage.mechanismId, '', (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$store.dispatch('setHomeLogo', 'null')
            localStorage.logo = 'null'
            this.oldLogo = 'null'
            this.cancelLogo()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      saveLogo () {
        if (!this.logoValue) {
          this.$message(this.$t('app_uploadPic'))
          return
        }

        var sizeVl = this.logoCheck ? 1 : 0
        console.log(sizeVl)

        this.loading = 1
        this.$editLogo(localStorage.mechanismId, this.logoValue, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.oldLogo = this.logoValue
            localStorage.logo = this.oldLogo
            this.cancelLogo()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      cancelLogo () {
        this.logo = ''
        this.logoValue = ''
        this.$store.dispatch('setHomeLogo', this.oldLogo)
      },
      handleBgAvatarSuccess (res, file) {
        this.loading = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.logoValue = res.data
          this.logo = URL.createObjectURL(file.raw)
          this.$store.dispatch('setHomeLogo', res.data)
        }
      },
      beforeBgAvatarUpload (file) {
        var size = file.size / 1024
        if (size > 200) {
          this.$message.error(this.$t('app_fileOver') + '200k')
          return false
        }
        this.loading = 1
        return true
      },
      formatStatus:function(row,column){
        return row.type == 0?this.$t('lin_global.label_areaid'):row.userStatus == 1?this.$t('lin_global.shebeibei'):'';
      },
			// 创建报警邮箱
      getAd1:function(){
        var params = {page:1,rows:10000};
        axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
          //console.log(res.data);
          var obj={
            'mechanismname':this.$t('lin_global.all_mechanism'),
            'mechanismid':''
          }
          this.areaList1 = res.data.data;

          this.areaList1.unshift(obj)
        })
      },
      onCreate () {

      },
      submitRow(type,config,mechId,terminalNo){
          var id = '';
          if(type==="0"){
              id = mechId;
          }else{
              id = terminalNo
          }
        var params = {targetType:type,targetId:id,conf:config};
        this.$confirm(this.$t('lin_global.wdct'), this.$t('lin_btn.tips'), {
          confirmButtonText:this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
        axios.post(`${baseurl}/sysConfig/setTmsServerConf.do`,params).then(res=>{
          //console.log("打印返回");
          //console.log(res.data);
          if(res.data.status == 200){
            this.$message.success(res.data.message);
          }else{
            this.$message.error(res.data.message);
          }

        })
        })
      },
      onChange (val) {
          //0也就是false显示渠道商
        this.value1 = '';
        if(val === '0'){
          this.isShow = false;
        }else{
          this.isShow = true;
        }
      },
      onSave(){
        this.$refs['setForm'].validate((valid)=>{

          if(valid){
            if (this.value === '2' && !this.exInfo) {
              this.$message.error(this.$t('app_plsUpl'))
              return
            }
            var host = this.setForm.url + ':' + this.setForm.port;
            var fn = this.exInfo.fileNo ? this.exInfo.fileNo : ''
            var params = {fileNo: fn, targetType:this.value,targetId:this.value1,conf:host}
            this.$confirm(this.$t('lin_global.tuisongtips')+host, this.$t('lin_btn.tips'), {
              confirmButtonText: this.$t('lin_btn.confirm'),
              cancelButtonText: this.$t('lin_btn.cancel'),
              type: 'warning'
            }).then(() => {
              this.isSubmit = true;
              this.loading = 1
              axios.post(`${baseurl}/sysConfig/setTmsServerConf.do`,params).then(res=>{
              //console.log("打印返回");
            //console.log(res.data);
            if(res.data.status == 200){
              this.loading = 0
              this.$message.success(res.data.message);
              this.isSubmit = false;
            }else{
              this.loading = 0
              this.$message.error(res.data.message);
              this.isSubmit = false;
            }

          })
          }).catch(() => {
            this.loading = 0
            })
          }else{
            this.loading = 0
            this.$message.error(this.$t('lin_global.refs'))
          return false
        }
      })

      },
      handleSizeChange: function (val) {
        this.pageSize = val
        this.getData(this.currentPage)
        //console.log(`每页 ${val} 条`)
      },
      handleCurrentChange: function (val) {
        this.currentPage = val
        this.getData(this.currentPage)
        //console.log('当前页: ${val}')
      },
      getData:function(page){
        this.currentPage = page;
        var params = {page:page,rows:this.pageSize};
        //console.log("看看是何方参数");
        //console.log(params);
        axios.post(`${baseurl}/sysConfig/terConfigCount.do`,params).then(res=>{
          //console.log("打印返回ORM列表")
          console.log('his res', res.data);
          this.arrdata = res.data.data;
          this.totalRecords = res.data.total;
          for(var i = 0;i<res.data.data.length;i++){
            if(res.data.data[i].failNum > 0){
              res.data.data[i]['submit'] = true;
            }else{
              res.data.data[i]['submit'] = false;
            }
          }
        })
      }
		},
    mounted () {
      this.oldLogo = localStorage.logo

      this.$getDvSetting((res) => {
        if (res.status === 200) {
          var data = res.data
          if (data.length > 0) {
            data = data[0]
            this.raw = data
            this.terminalConfigForm = JSON.parse(data.value)
            //console.log(this.raw)
          }
        } else {
           this.$message.error(res.message)
        }
      }, '')

    },
    beforeRouteLeave (to, from, next) {
      if (this.logo) {
        this.$showConfirm('', this.$t('app_logoLvTip'), this.$t('app_yes'), this.$t('app_no'), 'warning', () => {
            next()
            this.$store.dispatch('setHomeLogo', this.oldLogo)
          }, () => {
            // 取消
            return false
          })
      } else {
        next()
        this.$store.dispatch('setHomeLogo', this.oldLogo)
      }
    }
	}
</script>



// WEBPACK FOOTER //
// sysSetting.vue?6b21f234